module.exports = __webpack_public_path__ + "img/lbl04-last.51aa6e52.png";